import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { DanoneDnProductFamily } from 'src/app/assabil-sales/models/entities/danone-dn-product-family';
import { DanoneDnProductFamilyProduct } from 'src/app/assabil-sales/models/entities/danone-dn-product-family-product';
import { EntityContainer } from 'src/app/tools/models/entityContainer';
import { ProductLovComponent } from 'src/app/assabil-admin/components/master-data/product/product-lov/product-lov.component';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';
import { SalesAdminDanoneService } from 'src/app/assabil-sales/services/sales-admin-danone-service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'danone-dn-product-family-widget',
  templateUrl: './danone-dn-product-family-widget.component.html',
  styleUrls: ['./danone-dn-product-family-widget.component.scss']
})

export class DanoneDnProductFamilyWidgetComponent extends BaseWidget {
 

  productsColumns = [];

  danoneDnProductFamily                 : DanoneDnProductFamily = new DanoneDnProductFamily();
  danoneDnProductFamilyProductContainer : EntityContainer<DanoneDnProductFamilyProduct>;

  constructor(
    protected danoneService     : SalesAdminDanoneService,
    protected toastr            : ToastrService,
    protected leanUtilsService  : LeanUtilsService,
    protected dialog            : MatDialog,
    protected router            : Router) {
      super(toastr, leanUtilsService);
  }

  ngAfterViewInit(){
    super.ngAfterViewInit();
    
    this.productsColumns = [
       {prop : "product.name",             name : 'Produit',     modal :   ProductLovComponent,     readOnly  : true },
       {prop : "rank",                     name:  'Rang',       type   : 'number',                          }
    ];
  }


//------------------------------------------------------
 setEntity(danoneDnProductFamily: DanoneDnProductFamily) {
  this.danoneDnProductFamily = { ...danoneDnProductFamily };
    this.danoneDnProductFamily.danoneDnProductFamilyProducts = [];
    if (danoneDnProductFamily.danoneDnProductFamilyProducts) {
      for (let danoneDnProductFamilyProduct of danoneDnProductFamily.danoneDnProductFamilyProducts) {
        this.danoneDnProductFamily.danoneDnProductFamilyProducts.push({ ...danoneDnProductFamilyProduct });
      }
    }
}

//------------------------------------------------------
getEntity(){
  return this.danoneDnProductFamily;
}



//------------------------------------------------------
beforeValidate() : boolean{

  if (this.danoneDnProductFamily.dayNumber <=0) {
    this.showError("Le nombre de jours doit être supérieur à 0");
    return false;
  }
  if (this.danoneDnProductFamily.trendDaysNumber <=0) {
    this.showError("Le nombre de jours de la Tendance doit être supérieur à 0");
    return false;
  }
  return true;
}
//------------------------------------------------------


//------------------------------------------------------
saveRow() : Promise<DanoneDnProductFamily>{
  return this.danoneService.danoneDnProductFamilySave(this.danoneDnProductFamily);
}
//------------------------------------------------------


products : Product[];
//------------------------------------------------------------------------------------------------------
new(){
  let dialogRef = this.dialog.open(ProductLovComponent, {autoFocus: false,  hasBackdrop : false,  data : {dual : true, products : this.products}});
  dialogRef.afterClosed().subscribe(result => {
    if (result) {
      this.products = result.products;
      if (result.selectedProducts) {
        this.addProducts(result.selectedProducts)
      }
    }
  });
}
//------------------------------------------------------------------------------------------------------

//------------------------------------------------------
addProducts(products : Product[]){
  let rank : number = 100;
  for (let product of products){
      let nr = new DanoneDnProductFamilyProduct();
      nr.inserted = true;
      nr.edit      = true;
      nr.danoneDnProductFamilyCode = this.danoneDnProductFamily.danoneDnProductFamilyCode;
      nr.product  = new Product();
      nr.rank     = rank;
      rank        = rank +10;
      nr.product.productCode  = product.productCode;
      nr.product.name         = product.name;
      this.danoneDnProductFamily.danoneDnProductFamilyProducts.push(nr);
  }
  this.danoneDnProductFamily.danoneDnProductFamilyProducts = [...this.danoneDnProductFamily.danoneDnProductFamilyProducts];  
}

}

/*
//------------------------------------------------------
setSelectedProduct(result : DataModalResponse){
  let product = result.selectedRow;
  result.callerRow[result.fieldName] = product;
}
//------------------------------------------------------
*/